var _path, _path2, _path3, _path4, _circle, _path5, _line, _path6, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    stroke: "#2D5049",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 50.75L49 50.75",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14L28 50.75",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.75L22.75 8.75",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 8.75L45.5 8.75",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 8.75,
    r: 5.25,
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30.8269C21 36.0311 16.6907 40.25 11.375 40.25C6.05926 40.25 1.75 36.0311 1.75 30.8269L11.375 15.75L21 30.8269Z",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.0625,
    y1: 31.9375,
    x2: 19.6875,
    y2: 31.9375,
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.25 30.8269C54.25 36.0311 49.9407 40.25 44.625 40.25C39.3093 40.25 35 36.0311 35 30.8269L44.625 15.75L54.25 30.8269Z",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 36.3125,
    y1: 31.9375,
    x2: 52.9375,
    y2: 31.9375,
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/poll.a392f34098f9fe2b78bae09eecde8505.svg";
export { ForwardRef as ReactComponent };